/* Keep direct entrances useful; only go back within this storefront. */
(()=>{
 let fromStore=false;
 try{fromStore=!!document.referrer&&new URL(document.referrer).origin===location.origin&&history.length>1}catch{}
 function init(){document.querySelectorAll('[data-back-navigation]').forEach(link=>{
  if(link.dataset.backReady)return;link.dataset.backReady='1';
  link.setAttribute('aria-label',fromStore?'Wróć do poprzedniej strony':'Wróć na stronę główną');
  link.addEventListener('click',event=>{if(!fromStore||event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;event.preventDefault();history.back()});
 })}
 init();document.addEventListener('shopify:section:load',init);
})();
